<template>
  <div class="busqueda-miembro-wrapper">
    <v-autocomplete
      :items="miembros"
      :filter="customFilter"
      color="#C8FF4D"
      :loading="cargando"
      @input.native="buscarMiembros"
      item-text="nombre"
      item-value="id"
      clearable
      label="Escribe el nombre o la matrícula del miembro"
      return-object
      v-model="miembroSeleccionado"
      prepend-inner-icon="mdi-magnify"
      class="dark-autocomplete"
      solo
      flat
      hide-details
    >
      <template v-slot:no-data>
        <div class="empty-search-state">
          <v-icon size="22" color="#5C5C62" class="mb-2">mdi-account-search</v-icon>
          <p class="empty-search-text">No se encontraron resultados con "{{ busqueda }}"</p>
        </div>
      </template>

      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content v-text="data.item"></v-list-item-content>
        </template>
        <template v-else>
          <div class="miembro-search-item">
            <div class="miembro-search-avatar">
              <img :src="urlImagen(data.item.imagen)" alt="Miembro" />
            </div>
            <div class="miembro-search-info">
              <div class="miembro-search-name">{{ data.item.nombre }}</div>
              <div class="miembro-search-matricula">
                <v-icon size="11" class="mr-1" color="#5C5C62">mdi-card-account-details</v-icon>
                {{ data.item.matricula }}
              </div>
            </div>
          </div>
        </template>
      </template>

      <template v-slot:append>
        <v-icon v-if="cargando" size="16" color="#8C8C93" class="rotating">mdi-loading</v-icon>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import Utiles from "../../Servicios/Utiles";

export default {
  name: "BusquedaMiembro",

  data: () => ({
    cargando: false,
    busqueda: "",
    miembros: [],
    miembroSeleccionado: null,
  }),

  methods: {
    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    },

    async buscarMiembros(value) {
      if (value.data) {
        this.busqueda += value.data;

        let payload = {
          metodo: "obtener_nombre_matricula",
          busqueda: this.busqueda,
        };

        this.cargando = true;

        try {
          const resultados = await HttpService.obtenerConDatos(payload, "miembros.php");
          this.miembros = resultados;
        } catch (error) {
          console.error('Error buscando miembros:', error);
          this.miembros = [];
        } finally {
          this.cargando = false;
        }
      }
      this.busqueda = "";
    },

    customFilter(item, queryText, itemText) {
      const textOne = item.nombre.toLowerCase();
      const textTwo = item.matricula.toString();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },

    limpiarSeleccion() {
      this.miembroSeleccionado = null;
    }
  },

  watch: {
    miembroSeleccionado(miembro) {
      this.$emit("seleccionado", miembro);
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

.busqueda-miembro-wrapper {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --accent-dim: rgba(200, 255, 77, 0.12);
  --radius: 4px;

  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;

  width: 100%;
  font-family: var(--font-body);
}

/* ===== Overrides v-autocomplete (Vuetify) ===== */
.dark-autocomplete >>> .v-input__control {
  background: var(--bg);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  transition: border-color 0.15s ease;
  min-height: 42px;
}

.dark-autocomplete >>> .v-input__control:hover {
  border-color: var(--text-tertiary);
}

.dark-autocomplete.v-input--is-focused >>> .v-input__control {
  border-color: var(--accent) !important;
  box-shadow: 0 0 0 3px rgba(200, 255, 77, 0.12);
}

.dark-autocomplete >>> .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
}

.dark-autocomplete >>> .v-label {
  color: var(--text-tertiary) !important;
  font-size: 13.5px !important;
}

.dark-autocomplete >>> .v-input__prepend-inner {
  margin-top: 11px !important;
  color: var(--text-tertiary) !important;
}

.dark-autocomplete >>> .v-input__append-inner {
  margin-top: 11px !important;
}

.dark-autocomplete >>> input {
  color: var(--text-primary) !important;
  font-size: 13.5px !important;
  caret-color: var(--accent) !important;
}

.dark-autocomplete >>> .v-icon {
  color: var(--text-tertiary) !important;
}

/* ===== Empty state ===== */
.empty-search-state {
  padding: 24px;
  text-align: center;
}

.empty-search-text {
  font-size: 12.5px;
  color: var(--text-secondary);
  margin: 0;
}

/* ===== Item de la lista ===== */
.miembro-search-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  width: 100%;
}

.miembro-search-avatar {
  width: 34px;
  height: 34px;
  border-radius: var(--radius);
  overflow: hidden;
  flex-shrink: 0;
  border: 1px solid var(--card-border);
}

.miembro-search-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.miembro-search-info {
  flex: 1;
  min-width: 0;
}

.miembro-search-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 13px;
}

.miembro-search-matricula {
  display: flex;
  align-items: center;
  color: var(--text-tertiary);
  font-size: 11.5px;
  font-family: var(--font-mono);
  margin-top: 2px;
}

/* ===== Rotating loader ===== */
.rotating {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* ===== Menú desplegable (global, Vuetify lo monta fuera del componente) ===== */
:deep(.v-menu__content) {
  background: var(--card) !important;
  border: 1px solid var(--card-border) !important;
  border-radius: 4px !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5) !important;
}

:deep(.v-menu__content .v-list) {
  background: transparent !important;
  padding: 4px !important;
}

:deep(.v-menu__content .v-list-item) {
  color: var(--text-primary) !important;
  border-radius: 4px !important;
  min-height: 44px !important;
}

:deep(.v-menu__content .v-list-item:hover) {
  background: rgba(255, 255, 255, 0.04) !important;
}

:deep(.v-menu__content .v-list-item--highlighted) {
  background: rgba(255, 255, 255, 0.04) !important;
}

:deep(.v-menu__content .v-list-item__content) {
  color: var(--text-secondary) !important;
  padding: 4px 0 !important;
}

:deep(.v-menu__content .v-list-item__mask) {
  background: rgba(200, 255, 77, 0.25) !important;
  color: var(--accent) !important;
}

/* Responsive */
@media (max-width: 768px) {
  .miembro-search-avatar {
    width: 30px;
    height: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Miembros/BusquedaMiembro.vue